"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'landing.nav.about': 'Sul sistema',
    'landing.nav.modules': 'Moduli',
    'landing.nav.assistants': 'Assistenti IA',
    'landing.nav.contentStudio': 'Content Studio',
    'landing.nav.analytics': 'Analitica',
    'landing.nav.login': 'Accedi',
    'landing.hero.eyebrow': 'Piattaforma IA per aziende',
    'landing.hero.title1': 'Un dashboard.',
    'landing.hero.title2': 'Tutti i modelli IA',
    'landing.hero.title3': 'della tua azienda.',
    'landing.hero.lede': 'IntHub riunisce GPT-5, Claude, Gemini e DeepSeek in un unico posto — insieme ad assistenti, pianificazione contenuti, report costi e gestione del team. Senza cambiare tra una dozzina di strumenti.',
    'landing.hero.ctaLogin': 'Accedi al pannello',
    'landing.hero.ctaModules': 'Vedi moduli',
    'landing.hero.note': 'testhub.intgate.io — pannello disponibile per le aziende registrate',
    'landing.hero.deviceTitle': 'Inizia a parlare con il tuo assistente IA',
    'landing.hero.deviceSub': 'Scegli modello, stile di scrittura e collega la conoscenza — con un solo comando.',
    'landing.hero.deviceInput': '/ stile · # progetto · @ conoscenza — digita la tua domanda…',
    'landing.model.openai': 'OpenAI · GPT-5',
    'landing.model.claudeSonnet': 'Claude Sonnet 4.6',
    'landing.model.deepseek': 'DeepSeek V3.2',
    'landing.model.gemini': 'Gemini 3.5 Flash',
    'landing.model.claudeHaiku': 'Claude Haiku 4.5',
    'landing.intro.eyebrow': 'Introduzione',
    'landing.intro.title': 'Centro di comando IA per tutta l\'organizzazione',
    'landing.intro.lede1': 'Invece di disperdere il lavoro tra decine di schede, IntHub raccoglie conversazioni con modelli IA, assistenti virtuali, pianificazione contenuti e report costi in un unico sistema. Ogni azienda opera nel proprio spazio.',
    'landing.intro.lede2': 'Il sistema è multi-tenant dalla base: un account amministrativo può gestire più aziende, settori e team, e ogni operazione nel database viene registrata in un log di audit.',
    'landing.stat.providers': '4 fornitori',
    'landing.stat.providersLab': 'OpenAI, Anthropic, DeepSeek, Google — un\'interfaccia chat',
    'landing.stat.roles': '3 ruoli',
    'landing.stat.rolesLab': 'Super Admin, Manager, Utente — permessi precisi',
    'landing.stat.multitenant': 'Multi-tenant',
    'landing.stat.multitenantLab': 'Più aziende, settori e team in un sistema',
    'landing.stat.credits': 'Crediti',
    'landing.stat.creditsLab': 'Fatturazione uso IA in un modello di abbonamento trasparente',
    'landing.modules.eyebrow': 'Moduli',
    'landing.modules.title': 'Cosa troverai esattamente in IntHub',
    'landing.modules.lede': 'Nove moduli, un accesso. Ognuno copre una fase diversa del lavoro con IA in azienda — dalla conversazione alla fatturazione.',
    'landing.module.chat.title': 'Chat IA multi-modello',
    'landing.module.chat.desc': 'Chatta con GPT-5, Claude, Gemini o DeepSeek da una finestra. Con "/" cambi stile di scrittura, "#" colleghi un progetto, "@" la base di conoscenza.',
    'landing.module.assistants.title': 'Assistenti Virtuali',
    'landing.module.assistants.desc': 'Crea avatar con personalità, genere e modello IA propri. Ognuno passa attraverso una lista di compiti di formazione e ottiene la propria base di conoscenza prima di iniziare a lavorare.',
    'landing.module.knowledge.title': 'Base di Conoscenza',
    'landing.module.knowledge.desc': 'Collega documenti e dati aziendali a un assistente o progetto specifico, così le risposte si basano sui fatti della tua azienda.',
    'landing.module.contentStudio.title': 'Content Studio',
    'landing.module.contentStudio.desc': 'Pianifica post, assegna canali e traccia lo stato dalla bozza alla pubblicazione. L\'assistente IA suggerisce temi, piani contenuti e migliori orari di pubblicazione.',
    'landing.module.styles.title': 'Stili di Scrittura',
    'landing.module.styles.desc': 'Salva il tono di voce del brand — dal formale, come corrispondenza professionale, allo slang giovanile — e condividilo con tutto il team con un interruttore.',
    'landing.module.costs.title': 'Report Costi',
    'landing.module.costs.desc': 'Traccia token, costo per messaggio e avatar più attivi suddivisi per utente, azienda e periodo — con grafico di tendenza in tempo reale.',
    'landing.module.management.title': 'Gestione Aziende e Team',
    'landing.module.management.desc': 'Gestisci più aziende con moduli, settori e professioni separati. Assegna ruoli Super Admin, Manager e Utente a ogni account.',
    'landing.module.logs.title': 'Log di Audit e Accessi',
    'landing.module.logs.desc': 'Ogni creazione e aggiornamento di conversazione, messaggio o tasso di cambio va nel log del database — con vista completa dei dati di input e del risultato.',
    'landing.module.pricing.title': 'Piani e Pagamenti',
    'landing.module.pricing.desc': 'Dal piano gratuito a Ultra senza limiti — utenti, avatar e funzionalità crescono con la tua azienda, fatturati in crediti mensili.',
    'landing.assistants.eyebrow': 'Assistenti IA',
    'landing.assistants.title': 'Un team di bot che cresce con la tua azienda',
    'landing.assistants.lede': 'Ogni assistente è un dipendente IA separato: modello proprio, personalità, genere e ambito di conoscenza.',
    'landing.assistants.feature1': 'Qualsiasi modello per qualsiasi avatar — Claude, DeepSeek, Gemini',
    'landing.assistants.feature2': 'Lista di compiti di formazione prima di iniziare a lavorare',
    'landing.assistants.feature3': 'Base di conoscenza propria e vista a lista o griglia degli assistenti',
    'landing.avatar.historian': 'Storico',
    'landing.avatar.historianRole': 'Claude Sonnet 4.6',
    'landing.avatar.hive': 'Assistente HIVE',
    'landing.avatar.hiveRole': 'DeepSeek V3.2 · Programmatore',
    'landing.avatar.communicator': 'Comunicatore',
    'landing.avatar.communicatorRole': 'Gemini 3.5 Flash',
    'landing.avatar.whatsapp': 'Whatsapp',
    'landing.avatar.whatsappRole': 'Claude Haiku 4.5',
    'landing.avatar.statusConfig': 'Configurazione completata',
    'landing.cs.eyebrow': 'Content Studio',
    'landing.cs.title': 'Dall\'idea alla pubblicazione, senza fogli di calcolo',
    'landing.cs.lede': 'La libreria dei post mostra cosa è bozza, cosa attende approvazione e cosa è già pubblicato. Chiedi all\'assistente IA un tema, un piano settimanale o il miglior orario di pubblicazione.',
    'landing.cs.feature1': 'Stati: bozza, programmato, in attesa approvazione, pubblicato',
    'landing.cs.feature2': 'Calendario e storico pubblicazioni in un unico posto',
    'landing.cs.feature3': 'L\'assistente IA suggerisce temi basati sull\'engagement',
    'landing.cs.statScheduled': 'Programmati (7 giorni)',
    'landing.cs.statApproval': 'In attesa approvazione',
    'landing.cs.statPublished': 'Pubblicati (30 giorni)',
    'landing.cs.statTotal': 'Totale post',
    'landing.cs.postTitle': 'Testiamo l\'API',
    'landing.cs.postStatus': 'Pubblicato',
    'landing.cs.postContent': '"Ciao! Oggi mostriamo come testare un\'API passo dopo passo…"',
    'landing.cs.suggest1': 'Quali temi porteranno il miglior engagement?',
    'landing.cs.suggest2': 'Suggerisci un piano contenuti per la prossima settimana',
    'landing.cs.suggest3': 'Quando è meglio pubblicare?',
    'landing.analytics.eyebrow': 'Analitica',
    'landing.analytics.title': 'Ogni token conteggiato fino al centesimo',
    'landing.analytics.lede': 'Filtra report costi per data, utente, avatar o azienda. Vedi costo totale, numero di token, costo medio per messaggio e quale avatar genera più traffico.',
    'landing.analytics.feature1': 'Filtri per data, utente, avatar e azienda',
    'landing.analytics.feature2': 'Grafico di tendenza costi e token nel tempo',
    'landing.analytics.feature3': 'Classifica dell\'avatar più attivo nell\'organizzazione',
    'landing.analytics.totalCost': 'Costo totale',
    'landing.analytics.tokens': 'Token',
    'landing.analytics.messages': 'Messaggi',
    'landing.analytics.avgCost': 'Costo medio / messaggio',
    'landing.analytics.topMessages': 'Messaggi avatar top',
    'landing.analytics.topAvatar': 'Avatar top',
    'landing.management.eyebrow': 'Gestione e sicurezza',
    'landing.management.title': 'Struttura multi-azienda, controllo a ogni livello',
    'landing.management.lede': 'Un\'installazione gestisce più aziende, settori e professioni — e ogni cambiamento nel database viene registrato.',
    'landing.management.companies.title': 'Aziende, utenti, ruoli',
    'landing.management.companies.desc': 'Aggiungi aziende con NIP, indirizzo e moduli assegnati. Assegna a ogni account un ruolo.',
    'landing.management.logs.title': 'Log di audit del database',
    'landing.management.logs.desc': 'Filtra log per data, modello e tipo di operazione. Per ogni voce vedrai dati di input esatti e risultato.',
    'landing.management.table.company': 'Azienda',
    'landing.management.table.city': 'Città',
    'landing.management.table.status': 'Stato',
    'landing.management.table.model': 'Modello',
    'landing.management.table.operation': 'Operazione',
    'landing.management.table.date': 'Data',
    'landing.management.company1': 'Studio Nord Sp. z o.o.',
    'landing.management.company2': 'Kancelaria Wschód',
    'landing.management.company3': 'Biuro Rachunkowe Miller',
    'landing.management.warsaw': 'Varsavia',
    'landing.management.krakow': 'Cracovia',
    'landing.management.elk': 'Ełk',
    'landing.management.active': 'Attiva',
    'landing.management.opConversation': 'Conversazione',
    'landing.management.opMessage': 'Messaggio',
    'landing.management.opCurrency': 'Tasso di cambio',
    'landing.management.opCreate': 'Crea',
    'landing.management.opUpdate': 'Aggiorna',
    'landing.cta.eyebrow': 'Pronti per partire',
    'landing.cta.title': 'Centralizza l\'IA nella tua azienda oggi',
    'landing.cta.lede': 'Accedi al pannello di prova e configura il tuo primo assistente in pochi minuti.',
    'landing.cta.button': 'Vai al login',
    'landing.footer.copyright': '© 2026 IntHub. Tutti i diritti riservati.',
    'landing.footer.panel': 'Pannello di accesso',
    'landing.img.logo': 'IntHub',
    'landing.img.bg1': 'Postazione di lavoro con IA',
};
